import { mergeShapeOptionSources } from './customShapes';

/** Shapes that exist in inventory (API distinct values only). */
export function inventoryShapeOptions(inventoryShapes) {
  const fromApi = Array.isArray(inventoryShapes) ? inventoryShapes : [];
  return [...new Set(
    fromApi.filter(Boolean).map((s) => String(s).trim().toUpperCase()),
  )].sort();
}

/** Canonical shapes plus any from inventory API and company custom shapes (deduped, sorted). */
export function resolveShapeOptions(inventoryShapes, companyCustomShapes) {
  return mergeShapeOptionSources(inventoryShapes, companyCustomShapes);
}
